export default __webpack_public_path__ + "static/media/estrelas.2790adc3.png";